import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { PluginsType } from '../Types';
import api from '../API';
import { RootState } from '../store';

interface IPluginInfo {
    loading: 'idle' | 'pending' | 'succeeded' | 'failed';
    error?: string;
    source: any;
    plugins: PluginsType;
}

const initialState: IPluginInfo = {
    loading: 'idle',
    source: {},
    plugins: {
        DamaskWebApiModule: false,
        EnterEQ: false,
        ReturnEQ: false,
        IsNewUIEnabled: false,
		Messaging: false,
		authEsia: false,
		vkNotifyModule: false
    }
};

export const getPluginInfo = createAsyncThunk('pluginInfo/Get', async () => {
      const response = await api.Plugins.get();
      return response;
    }
);

export const pluginInfoSlicer = createSlice({
	name: 'pluginInfo',
	initialState,
	reducers: {},
    extraReducers: (builder) => {
        builder.addCase( getPluginInfo.pending, (state) => {
            state.loading = "pending";
        });
        builder.addCase( getPluginInfo.fulfilled, (state, action) => {
            if ( !!action.payload && typeof action.payload !== "string" ) {
                window.RDC.localStorage.setItem( 'plugins', JSON.stringify(action.payload) );
                state.source = { ...action.payload };
                state.plugins = {
                    DamaskWebApiModule: !!action.payload["Nvx.ReDoc.DamaskWebApiModule"],
                    EnterEQ: !!action.payload["Nvx.ReDoc.EnterEQ"],
                    ReturnEQ: !!action.payload["Nvx.ReDoc.ReturnEQ"],
                    IsNewUIEnabled: action.payload.IsNewUIEnabled === true,
						Messaging: !!action.payload["Nvx.ReDoc.Workflow.PushMessage"],
						authEsia: !!action.payload["Nvx.ReDoc.EsiaConnect"],
						vkNotifyModule: !!action.payload["Nvx.ReDoc.VkNotifyModule"],
                    version: action.payload.version
                } as PluginsType;
                state.loading = 'succeeded';
                return state;
            }
            return state;
        });
        builder.addCase( getPluginInfo.rejected, (state, action) => {
            window.RDC.localStorage.removeItem( 'plugins');
            state.error = action.error.message;
            state.loading = "pending";
        });
    }
});

export const getUserInfoSelector = (store:RootState):IPluginInfo => store.pluginInfo; 

export default pluginInfoSlicer;